var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonTimer"},[_c('s-button',{attrs:{"label":_vm.delay == null ? _vm.timerTournoi + 'mn' : _vm.delay,"icon":"","afterIcon":_vm.icon,"theme":_vm.theme + _vm.color},on:{"onclick":_vm.setTimer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }